import List from '../components/Disclosure/List'
import Graphs from '../components/Disclosure/Graphs'

let routes = {
    path: '/disclosures',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
      {
          path: '/worker/disclosures',
          name: 'Divulgações',
          component: List
      },
      {
        path: '/worker/disclosure/:id',
        name: 'Divulgação',
        component: Graphs
    },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/disclosure.js